import createVpn from '@/common/store/modules/vpn/createVpn';
import { pick } from 'lodash-es';
import Vue from 'vue';

export default {
  name: 'vpn',
  Model: Object,
  socketUpdates: true,
  pagingSupport: false,
  namespaced: true,
  resource: '/api/v2/compute/vpn/ipsec-site-connections',
  state: {
    endpoints: [],
    ipsec: [],
    ike: [],
    services: {}
  },
  getters: {
    _mapItem: (state, getters, _, rootGetters) => id => state.itemsMap[id] && createVpn(state.itemsMap[id], getters, rootGetters),
    getPolicies: state => policy => state[policy],
    getEndpointsGroups: state => state.endpoints,
    getEndpointsGroup: state => groupId => state.endpoints.find(it => it.id === groupId),
    getVpnServiceInfo: state => id => state.services[id],
    getResourceById: state => id => [...state.endpoints, ...state.ipsec, ...state.ike].find(it => it.id === id),
    getVpnConnectionByResources: (state, getters) => resourceId => getters.getItems.filter(
      (item) => Object.values(pick(item, ['peer_ep_group_id', 'local_ep_group_id', 'ipsecpolicy_id', 'ikepolicy_id'])).includes(resourceId)
    )
  },
  mutations: {
    SET_POLICIES(state, { policy, items }) {
      state[policy] = items;
    },
    SET_EP_GROUPS(state, endpoints) {
      state.endpoints = endpoints;
    },
    SET_VPN_SERVICE_INFO(state, service) {
      Vue.set(state.services, service.id, service);
    }
  },
  actions: () => ({
    FETCH_IP_SEC_POLICIES({ commit }) {
      return this.$api.get('/api/v2/compute/vpn/ipsecpolicies/')
        .then(({ data }) => {
          commit('SET_POLICIES', { policy: 'ipsec', items: data.data });
        });
    },
    FETCH_IKE_POLICIES({ commit }) {
      return this.$api.get('/api/v2/compute/vpn/ikepolicies/')
        .then(({ data }) => {
          commit('SET_POLICIES', { policy: 'ike', items: data.data });
        });
    },
    FETCH_ENDPOINTS_GROUPS({ commit }) {
      return this.$api.get('/api/v2/compute/vpn/endpoint-groups')
        .then(({ data }) => {
          commit('SET_EP_GROUPS', data.data);
        });
    },
    FETCH_VPN_SERVICE_INFO({ commit }, { id }) {
      return this.$api.get(`/api/v2/compute/vpn/vpnservices/${id}/`)
        .then(({ data }) => {
          commit('SET_VPN_SERVICE_INFO', data);
        });
    },
    RESTART(store, id) {
      return this.$api.post(`/api/v2/compute/vpn/ipsec-site-connections/${id}/restart/`);
    }
  })
};
